// ----------------------------------------------------------------------------
// Product Form Extension: Product Form Sale Indicator
// ----------------------------------------------------------------------------
// Adds/Removes the '--on-sale' class on the product form element when the
// selected variant is on sale (e.g. show a "Sale" badge)
// ----------------------------------------------------------------------------
// Customization:
// - Write CSS to show/hide relevant elements within the product form based on
//   the the presence of the `--on-sale` class.
// ----------------------------------------------------------------------------
// Event Listener:
// - 'productForm:variant:changed' → Triggered when the selected variant changes
//                                   to modify the product form classes
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Toggles the '--on-sale' CSS class on the product form element if the variant
//   is on sale (compare_at_price > price)
// ----------------------------------------------------------------------------
// Gotchas:
// - Only updates the `--on-sale` class, specific content (e.g. badges) must be
//   defined separately in Liquid
// - The CSS to show/hide items based on the `--on-sale` class must be defined separately
// - If no variant is selected, the function assumes the product is not on sale
//   and removes the '--on-sale' class
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';

// -------------------------------------
// Event Listeners
// -------------------------------------

iamotaEventHandler.subscribe('productForm:variant:changed', _ref => {
  var {
    iamProductForm,
    variant
  } = _ref;
  // No variant
  if (!variant) {
    iamProductForm.classList.remove('--on-sale');
    return;
  }

  // Update the "Sale" state
  iamProductForm.classList.toggle('--on-sale', variant.compare_at_price > variant.price);
}, {
  source: "product-form--on-sale.js"
});